// extracted by mini-css-extract-plugin
export default {"card":"K5-z"};